import request from '@/utils/request';

// 获取市区字典 二级联动
export function getAddressDict() {
  return request({
    url: '/subject/reception/dict/address',
    method: 'get',
  });
}

// 获取园区字典
export function getParkDict() {
  return request({
    url: '/subject/reception/dict/park',
    method: 'get',
  });
}

// 获取高校字典
export function getSchoolDict() {
  return request({
    url: '/subject/reception/dict/school',
    method: 'get',
  });
}

// 获取职称字典
export function getSchoolTitleDict() {
  return request({
    url: '/subject/reception/dict/school/title',
    method: 'get',
  });
}

// 获取企业需求类别字典
export function getTypeTitleDict() {
  return request({
    url: '/subject/reception/dict/companyDemand/typetitle',
    method: 'get',
  });
}

// 获取企业需求拟合作方式字典
export function getFormDict() {
  return request({
    url: '/subject/reception/dict/companyDemand/form',
    method: 'get',
  });
}

// 企业荣誉
export function getCompanyDemandHonorDict() {
  return request({
    url: '/subject/reception/dict/companyDemand/honor',
    method: 'get',
  });
}

// 企业需求类型
export function getCompanyDemandTypeDict() {
  return request({
    url: '/subject/reception/dict/companyDemand/type',
    method: 'get',
  });
}

// 专业领域
export function getIndustryDict() {
  return request({
    url: '/subject/reception/dict/industry',
    method: 'get',
  });
}

// 企业需求合作方式
export function getCompanyDemandFormDict() {
  return request({
    url: '/subject/reception/dict/companyDemand/form',
    method: 'get',
  });
}

// 根据参数键名查询参数值
export function getConfigKey(configKey) {
  return request({
    url: '/system/config/configKey/' + configKey,
    method: 'get'
  })
}

// 获取转化方式字典
export function getResearchMethodDict() {
  return request({
    url: '/subject/reception/dict/researchMethod',
    method: 'get',
  });
}
